import React from "react";

const Icon = ({ type }) => {
  return (
    <>
      {type === "about" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M13.272 21.1852V24.0002C16.0377 23.8365 18.63 22.7953 20.705 21.0146L18.6489 19.0209C17.1743 20.2371 15.3133 21.0253 13.272 21.1852Z"
            fill="white"
          />
          <path
            d="M21.9723 12.7485C21.8075 14.728 20.9946 16.5326 19.7404 17.9625L21.7964 19.9563C23.6328 17.9442 24.7066 15.4304 24.8753 12.7485H21.9723Z"
            fill="white"
          />
          <path
            d="M11.7281 2.81523V0.000244141C8.96235 0.163885 6.37003 1.20512 4.29504 2.98581L6.35108 4.97954C7.82579 3.76328 9.68673 2.97507 11.7281 2.81523Z"
            fill="white"
          />
          <path
            d="M12.4998 4.28149C8.11066 4.28149 4.53979 7.74415 4.53979 12.0003C4.53979 16.2565 8.11066 19.7191 12.4998 19.7191C16.889 19.7191 20.4598 16.2565 20.4598 12.0003C20.4598 7.74415 16.889 4.28149 12.4998 4.28149ZM12.3491 11.0556H12.6505C13.8477 11.0556 14.8217 12.0001 14.8217 13.1611C14.8217 14.1128 14.167 14.9186 13.2716 15.1783V16.6677H11.7281V15.1783C10.8326 14.9186 10.1779 14.1128 10.1779 13.1611H11.7214C11.7214 13.4967 12.003 13.7698 12.3491 13.7698H12.6505C12.9966 13.7698 13.2782 13.4967 13.2782 13.1611C13.2782 12.8254 12.9966 12.5524 12.6505 12.5524H12.3491C11.1519 12.5524 10.1779 11.6079 10.1779 10.4469C10.1779 9.49526 10.8326 8.68943 11.7281 8.4297V6.94029H13.2716V8.4297C14.167 8.68943 14.8217 9.49521 14.8217 10.4469H13.2782C13.2782 10.1113 12.9966 9.8382 12.6505 9.8382H12.3491C12.003 9.8382 11.7214 10.1112 11.7214 10.4469C11.7214 10.7826 12.003 11.0556 12.3491 11.0556Z"
            fill="white"
          />
          <path
            d="M18.6489 4.97954L20.7049 2.98581C18.63 1.20512 16.0377 0.163885 13.272 0.000244141V2.81523C15.3133 2.97507 17.1743 3.76328 18.6489 4.97954Z"
            fill="white"
          />
          <path
            d="M5.2599 6.03793L3.20386 4.04419C1.36753 6.05625 0.293754 8.57002 0.125 11.2519H3.028C3.19284 9.27244 4.00563 7.4679 5.2599 6.03793Z"
            fill="white"
          />
          <path
            d="M3.028 12.7485H0.125C0.293754 15.4304 1.36753 17.9442 3.20381 19.9563L5.2599 17.9625C4.00563 16.5326 3.19284 14.728 3.028 12.7485Z"
            fill="white"
          />
          <path
            d="M6.35113 19.0209L4.29504 21.0146C6.37003 22.7953 8.96235 23.8365 11.7281 24.0002V21.1852C9.68673 21.0253 7.82579 20.2371 6.35113 19.0209Z"
            fill="white"
          />
          <path
            d="M21.9724 11.2519H24.8753C24.7066 8.57002 23.6328 6.05625 21.7964 4.04419L19.7404 6.03793C20.9947 7.4679 21.8075 9.27244 21.9724 11.2519Z"
            fill="white"
          />
        </svg>
      )}
      {type === "plans" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M8.11925 0.000244141H2.85575C1.3476 0.000244141 0.125 1.18579 0.125 2.64824V7.75224C0.125 9.21469 1.3476 10.4002 2.85575 10.4002H8.11925C9.6274 10.4002 10.85 9.21469 10.85 7.75224V2.64824C10.85 1.18579 9.6274 0.000244141 8.11925 0.000244141Z"
            fill="white"
          />
          <path
            d="M22.1443 0.000244141H16.8808C15.3726 0.000244141 14.15 1.18579 14.15 2.64824V7.75224C14.15 9.21469 15.3726 10.4002 16.8808 10.4002H22.1443C23.6524 10.4002 24.875 9.21469 24.875 7.75224V2.64824C24.875 1.18579 23.6524 0.000244141 22.1443 0.000244141Z"
            fill="white"
          />
          <path
            d="M8.11925 13.6002H2.85575C1.3476 13.6002 0.125 14.7858 0.125 16.2482V21.3522C0.125 22.8147 1.3476 24.0002 2.85575 24.0002H8.11925C9.6274 24.0002 10.85 22.8147 10.85 21.3522V16.2482C10.85 14.7858 9.6274 13.6002 8.11925 13.6002Z"
            fill="white"
          />
          <path
            d="M19.5125 24.0002C22.4742 24.0002 24.875 21.6721 24.875 18.8002C24.875 15.9283 22.4742 13.6002 19.5125 13.6002C16.5509 13.6002 14.15 15.9283 14.15 18.8002C14.15 21.6721 16.5509 24.0002 19.5125 24.0002Z"
            fill="white"
          />
        </svg>
      )}
      {type === "platforms" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="20"
          viewBox="0 0 25 20"
          fill="none"
        >
          <path
            d="M0.125 0.000244141L6.98786 2.64559V20.0002L0.125 17.3553V0.000244141Z"
            fill="white"
          />
          <path
            d="M9.06885 2.64559L15.931 0.000244141V17.3553L9.06885 20.0002V2.64559Z"
            fill="white"
          />
          <path
            d="M24.875 20.0002L18.0117 17.3553V0.000244141L24.875 2.64559V20.0002Z"
            fill="white"
          />
        </svg>
      )}
      {type === "offers" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="29"
          viewBox="0 0 22 29"
          fill="none"
        >
          <path
            d="M13.847 0.655363C12.3836 0.856127 10.3215 1.89193 8.39247 3.40487C7.47789 4.11533 5.79286 5.76929 5.03891 6.69127C2.12874 10.2543 0.670908 14.1806 0.953676 17.7055C1.37508 22.9171 4.19639 26.7622 8.48682 27.9715C11.8957 28.9315 15.6596 28.1505 18.3148 25.9268C20.166 24.3759 21.3911 22.0549 21.6073 19.6958C21.6904 18.7631 21.3856 17.4939 20.8479 16.5722C20.2545 15.558 19.4398 14.6306 17.7325 13.02C16.6573 12.0057 16.646 11.9949 16.369 11.4473C15.8758 10.4712 15.6984 9.4354 15.8148 8.17702C15.87 7.55888 16.02 6.68022 16.1751 6.07822C16.2139 5.9372 16.2084 5.93182 15.9977 5.93182C15.4599 5.93182 14.6562 6.24642 13.8858 6.76149C13.6363 6.93507 13.4201 7.07071 13.4091 7.07071C13.3926 7.07071 13.3535 6.89713 13.3205 6.68022C13.2207 6.12154 13.2817 4.68449 13.4259 4.0771C13.6143 3.27462 13.9138 2.47185 14.3737 1.54449C14.6177 1.05632 14.8171 0.649698 14.8171 0.638939C14.8168 0.611753 14.0687 0.62818 13.847 0.655363ZM12.3504 11.7726C12.0013 12.6023 11.8126 13.432 11.8126 14.175C11.8181 15.0916 12.0786 15.8074 12.6939 16.5612C13.093 17.0548 13.5144 17.4181 14.6782 18.2967C16.1858 19.4302 16.6625 19.902 17.0286 20.6286C17.2781 21.1111 17.3389 21.4149 17.3334 22.0656C17.3166 24.0395 16.075 25.8563 14.1349 26.7565C13.8855 26.8757 13.614 26.9842 13.5306 27.006L13.381 27.0385L13.5416 26.7457C13.8577 26.1817 13.9462 25.4658 13.7911 24.8151C13.6082 24.0613 13.1593 23.4811 12.0673 22.6079C11.0587 21.7892 10.7982 21.4149 10.8037 20.7481L10.8092 20.3522L10.4821 20.6668C9.66189 21.4531 9.10735 22.5376 8.85787 23.8609C8.7858 24.2188 8.7693 24.5388 8.7858 25.13C8.81358 25.9217 8.83558 26.0302 9.13513 26.7188C9.17392 26.8111 9.15742 26.8111 8.93543 26.7027C8.53631 26.5019 8.21476 26.2689 7.78236 25.8676C6.8345 24.9728 6.26896 23.9857 5.87563 22.5269C5.715 21.941 5.70921 21.8436 5.70372 20.8457C5.69822 19.9291 5.71471 19.7122 5.82556 19.2241C6.1804 17.6839 6.92856 16.1492 8.01506 14.7447C8.48624 14.1427 9.42861 13.2046 10.0161 12.7544C10.8864 12.0929 11.5405 11.7944 12.3443 11.686C12.3669 11.686 12.3723 11.7239 12.3504 11.7726Z"
            fill="white"
          />
        </svg>
      )}
      {type === "faq" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M12.5 0C10.0525 0 7.65988 0.703787 5.62482 2.02236C3.58976 3.34094 2.00363 5.21508 1.067 7.4078C0.130362 9.60051 -0.114704 12.0133 0.362788 14.3411C0.84028 16.6688 2.01888 18.807 3.74956 20.4853C5.48023 22.1635 7.68525 23.3064 10.0858 23.7694C12.4863 24.2324 14.9745 23.9948 17.2357 23.0865C19.4969 22.1783 21.4297 20.6402 22.7894 18.6668C24.1492 16.6934 24.875 14.3734 24.875 12C24.8714 8.81845 23.5665 5.76821 21.2465 3.51852C18.9265 1.26883 15.781 0.00344108 12.5 0V0ZM12.5 19C12.296 19 12.0967 18.9413 11.9271 18.8315C11.7575 18.7216 11.6253 18.5654 11.5473 18.3827C11.4692 18.1999 11.4488 17.9989 11.4886 17.8049C11.5284 17.6109 11.6266 17.4327 11.7708 17.2929C11.915 17.153 12.0988 17.0578 12.2988 17.0192C12.4989 16.9806 12.7062 17.0004 12.8946 17.0761C13.0831 17.1518 13.2441 17.28 13.3575 17.4444C13.4708 17.6089 13.5313 17.8022 13.5313 18C13.5313 18.2652 13.4226 18.5196 13.2292 18.7071C13.0358 18.8946 12.7735 19 12.5 19ZM14.0747 12.7C13.9058 12.7797 13.7645 12.9053 13.668 13.0616C13.5714 13.2178 13.5239 13.398 13.5313 13.58V14C13.5313 14.2652 13.4226 14.5196 13.2292 14.7071C13.0358 14.8946 12.7735 15 12.5 15C12.2265 15 11.9642 14.8946 11.7708 14.7071C11.5774 14.5196 11.4688 14.2652 11.4688 14V13.58C11.4581 13.0011 11.6254 12.4322 11.9494 11.9458C12.2734 11.4595 12.7393 11.0776 13.2879 10.849C13.7258 10.6732 14.0879 10.3565 14.3133 9.95215C14.5387 9.54783 14.6136 9.08058 14.5254 8.629C14.4459 8.23328 14.2465 7.86959 13.9525 7.58453C13.6585 7.29946 13.2835 7.10602 12.8754 7.029C12.5774 6.97552 12.2709 6.98636 11.9778 7.06076C11.6846 7.13517 11.412 7.2713 11.1792 7.45947C10.9465 7.64764 10.7593 7.88324 10.6311 8.1495C10.503 8.41576 10.4368 8.70615 10.4375 9C10.4375 9.26521 10.3289 9.51957 10.1355 9.7071C9.94206 9.89464 9.67976 10 9.40625 10C9.13275 10 8.87045 9.89464 8.67705 9.7071C8.48365 9.51957 8.375 9.26521 8.375 9C8.37555 8.2756 8.57896 7.56494 8.9635 6.94389C9.34805 6.32283 9.8993 5.8147 10.5584 5.47374C11.2175 5.13277 11.9597 4.97177 12.7059 5.00792C13.452 5.04407 14.1739 5.27602 14.7947 5.679C15.4155 6.08198 15.9118 6.64086 16.2306 7.29599C16.5493 7.95112 16.6787 8.6779 16.6048 9.39875C16.5308 10.1196 16.2564 10.8074 15.8108 11.3889C15.3652 11.9703 14.7652 12.4235 14.0747 12.7Z"
            fill="white"
          />
        </svg>
      )}
      {type === "sign_up" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M23.8647 12.3653C24.3136 11.9436 24.631 11.4093 24.7812 10.8229C24.9314 10.2364 24.9083 9.62114 24.7145 9.04667C24.5207 8.47219 24.164 7.9614 23.6847 7.57203C23.2054 7.18267 22.6226 6.93027 22.0022 6.84336L18.0478 6.2868C17.8855 6.2639 17.7314 6.20339 17.5987 6.11046C17.4661 6.01753 17.3588 5.89496 17.2861 5.75328L15.5169 2.30335C15.2393 1.762 14.8102 1.30623 14.2779 0.987556C13.7457 0.66888 13.1315 0.5 12.5049 0.5C11.8782 0.5 11.264 0.66888 10.7318 0.987556C10.1995 1.30623 9.77036 1.762 9.49283 2.30335L7.72192 5.75646C7.64933 5.89804 7.54219 6.02055 7.40967 6.11347C7.27715 6.20639 7.12322 6.26696 6.96108 6.28998L3.00584 6.84655C2.38543 6.93345 1.80263 7.18585 1.32332 7.57522C0.844015 7.96458 0.487315 8.47537 0.29355 9.04985C0.099785 9.62432 0.0766822 10.2396 0.226854 10.826C0.377025 11.4125 0.694481 11.9468 1.14333 12.3685L4.00434 15.0528C4.12181 15.163 4.20965 15.2992 4.26026 15.4495C4.31086 15.5998 4.32273 15.7597 4.29482 15.9155L3.61979 19.7113C3.51185 20.3072 3.57959 20.9203 3.81532 21.481C4.05104 22.0416 4.44531 22.5273 4.95328 22.8828C5.46125 23.2383 6.06255 23.4494 6.68882 23.492C7.31508 23.5346 7.9412 23.407 8.49597 23.1238L12.0337 21.3333C12.1787 21.2597 12.3401 21.2212 12.504 21.2212C12.6679 21.2212 12.8294 21.2597 12.9744 21.3333L16.5113 23.1238C17.0662 23.4053 17.6919 23.5315 18.3175 23.4881C18.943 23.4448 19.5435 23.2336 20.051 22.8785C20.5584 22.5234 20.9526 22.0386 21.189 21.4789C21.4253 20.9191 21.4943 20.3068 21.3883 19.7113L20.7124 15.9162C20.6845 15.7605 20.6964 15.6006 20.747 15.4503C20.7976 15.3 20.8854 15.1638 21.0029 15.0536L23.8647 12.3653Z"
            fill="white"
          />
        </svg>
      )}
    </>
  );
};

export default Icon;
